import { getAuthToken, setAuthToken, removeAuthToken } from './browser_state';
import { apiPost, apiGet } from './api';

export const isLoggedIn = () =>
    getAuthToken().then(token => !!token);

export const login = async ({ username, password }) => {
    if (!username || !password) return false;

    if (!!(await getAuthToken())) return true;

    const formdata = new FormData();
    formdata.append('username', username);
    formdata.append('password', password);

    try {
        const response = await apiPost('/api-token-auth/', formdata);
        const data = await response.json();
        if (!response.ok || !data.token) {
            console.error('Login failed:', response.status, data);
            return false;
        }
        await setAuthToken(data.token);
        return { token: data.token };
    } catch (error) {
        console.error('Login error:', error);
        return false;
    }
};

export const logout = async () => {
    await removeAuthToken();
    return true;
};

export const register = async ({ username, password, passwordConfirm, firstName, lastName, email }) => {
    const formdata = new FormData();
    formdata.append('username', username);
    formdata.append('password', password);
    formdata.append('password_confirm', passwordConfirm);
    formdata.append('first_name', firstName);
    formdata.append('last_name', lastName);
    formdata.append('email', email);

    try {
        const response = await apiPost('/api/v1/accounts/register/', formdata);
        const data = await response.json();

        if (data['id']) return true;

        const errors = [];
        if (data['username']) errors.push(...data['username']);
        if (data['password']) errors.push(...data['password']);
        if (data['email']) errors.push(...data['email']);
        return errors.length > 0 ? errors : false;
    } catch (error) {
        console.error('Register error:', error);
        return false;
    }
};

export const getUser = async () => {
    const response = await apiGet('/api/v1/users/');
    const users = await response.json();
    return users[0];
};
